import { ScoreRing } from '../components/ScoreRing';
import { SubScoreCard } from '../components/SubScoreCard';
import { MetricRow } from '../components/MetricRow';
import { Card } from '../components/Card';
import { DailyInsightCard } from '../components/DailyInsightCard';
import { useHealthData } from '../services/HealthDataContext';
import { getMetricSeries } from '../services/metrics';
import { formatMinutesAsHours, METRIC_LABELS, METRIC_UNITS } from '../services/labels';

export function TodayScreen() {
  const { today, todayKey, scores, baselines, historyByDate } = useHealthData();

  const series = (metric: Parameters<typeof getMetricSeries>[1]) =>
    getMetricSeries(historyByDate, metric, todayKey, 14).map((point) => point.value);

  return (
    <div className="screen screen--today">
      <p className="screen__greeting">Hola, Ivan</p>

      <div className="readiness-block">
        <ScoreRing score={scores.readinessScore} label="Preparacion" size={188} />
      </div>

      <div className="sub-score-grid">
        <SubScoreCard to="/sueno" label="Sueno" score={scores.sleepScore} />
        <SubScoreCard to="/recuperacion" label="Recuperacion" score={scores.recoveryScore} />
        <SubScoreCard to="/actividad" label="Actividad" score={scores.activityScore} />
        <SubScoreCard to="/nutricion" label="Nutricion" score={scores.nutritionScore} />
      </div>

      <Card title="Metricas de hoy" subtitle="Comparadas con tu baseline personal">
        <div className="metric-grid">
          <MetricRow
            label={METRIC_LABELS.hrv}
            value={String(today.recovery.hrv)}
            unit={METRIC_UNITS.hrv}
            baseline={baselines.metrics.hrv?.[30]}
            series={series('hrv')}
          />
          <MetricRow
            label={METRIC_LABELS.restingHeartRate}
            value={String(today.recovery.restingHeartRate)}
            unit={METRIC_UNITS.restingHeartRate}
            baseline={baselines.metrics.restingHeartRate?.[30]}
            series={series('restingHeartRate')}
          />
          <MetricRow
            label={METRIC_LABELS.spo2}
            value={String(today.recovery.spo2)}
            unit={METRIC_UNITS.spo2}
            baseline={baselines.metrics.spo2?.[30]}
            series={series('spo2')}
          />
          <MetricRow
            label={METRIC_LABELS.respiratoryRate}
            value={String(today.recovery.respiratoryRate)}
            unit={METRIC_UNITS.respiratoryRate}
            baseline={baselines.metrics.respiratoryRate?.[30]}
            series={series('respiratoryRate')}
          />
          <MetricRow
            label={METRIC_LABELS.sleepDuration}
            value={formatMinutesAsHours(today.sleep.totalMinutes)}
            baseline={baselines.metrics.sleepDuration?.[30]}
            series={series('sleepDuration')}
          />
          <MetricRow
            label={METRIC_LABELS.steps}
            value={today.activity.steps.toLocaleString('es-ES')}
            baseline={baselines.metrics.steps?.[30]}
            series={series('steps')}
          />
          <MetricRow
            label={METRIC_LABELS.nutritionCalories}
            value={String(today.nutrition.calories)}
            unit={METRIC_UNITS.nutritionCalories}
            baseline={baselines.metrics.nutritionCalories?.[30]}
            series={series('nutritionCalories')}
          />
          <MetricRow
            label={METRIC_LABELS.proteinIntake}
            value={String(today.nutrition.protein)}
            unit={METRIC_UNITS.proteinIntake}
            baseline={baselines.metrics.proteinIntake?.[30]}
            series={series('proteinIntake')}
          />
        </div>
      </Card>

      <DailyInsightCard />
    </div>
  );
}
